module.exports = __webpack_public_path__ + "static/media/Pre-Function.66ce4b22.jpg";